"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const auth_credential_util_1 = require("../../util/auth-credential-util");
const auth_session_util_1 = require("../../util/auth-session-util");
const useAuth = () => {
    return { getAuthSession: auth_session_util_1.getAuthSession, getAuthCredentials: auth_credential_util_1.getAuthHeaders };
};
exports.default = useAuth;
